import Seyfert from './Seyfert'

export default Seyfert
